export default __webpack_public_path__ + "static/media/warning--koala-crossing--g2.89b90763.png";